<template>
  <item-base
    :route-name="routeName"
    icon="person-fill"
  >
    ユーザー情報
  </item-base>
</template>

<script>
import ItemBase from './Base'

export default {
  components: {
    ItemBase
  },

  data () {
    return {
      routeName: 'user-info'
    }
  }
}
</script>
